import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
export default observer(function CustomerReviewsComponent(cat,key) {     
    const currentyear = new Date().getFullYear();    
    return (
        <section data-bs-version="5.1" className="people4 shopm5 cid-uATHtCsGlY" id="apeople4-8">
    <div className="container">
        <div className="mbr-section-head">
            <h3 className="mbr-section-title mbr-fonts-style mb-0 align-center display-2">
                <strong>Customer reviews</strong>
            </h3>
            <h5 className="mbr-section-subtitle mbr-fonts-style mb-0 align-center display-4">
                Look through the reviews of our customers.
            </h5>
        </div>
        <div className="row cards-row align-items-stretch justify-content-center">

            <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                    <div className="icons-wrap">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                    </div>
                    <h5 className="card-title mbr-fonts-style display-4">
                        <strong>Great Quality!</strong>
                    </h5>
                    <h5 className="card-subtitle mbr-fonts-style mb-0 display-7">I couldn't find the threads for a certain material. It was only one place, where they were.</h5>
                    <div className="card-bottom-wrap">
                        <p className="card-name mbr-fonts-style mb-0 display-7">
                            <strong>Adam Cross</strong>
                        </p>
                        <p className="card-text mbr-fonts-style mb-0 display-7">
                            France
                        </p>
                    </div>
                </div>
            </div>

            <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                    <div className="icons-wrap">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                    </div>
                    <h5 className="card-title mbr-fonts-style display-4">
                        <strong>Free shipping!</strong>
                    </h5>
                    <h5 className="card-subtitle mbr-fonts-style mb-0 display-7">Ordered a textile for my kitchen table. It was delivered on time.</h5>
                    <div className="card-bottom-wrap">
                        <p className="card-name mbr-fonts-style mb-0 display-7">
                            <strong>Susan Crossman</strong>
                        </p>
                        <p className="card-text mbr-fonts-style mb-0 display-7">
                            Staten Island
                        </p>
                    </div>
                </div>
            </div>
            <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                    <div className="icons-wrap">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                    </div>
                    <h5 className="card-title mbr-fonts-style display-4">
                        <strong>Secured payments!</strong>
                    </h5>
                    <h5 className="card-subtitle mbr-fonts-style mb-0 display-7">The shop has a simple and secure system. I had no troubles with it.</h5>
                    <div className="card-bottom-wrap">
                        <p className="card-name mbr-fonts-style mb-0 display-7">
                            <strong>Adam Cross</strong>
                        </p>
                        <p className="card-text mbr-fonts-style mb-0 display-7">
                            United States
                        </p>
                    </div>
                </div>
            </div>

            <div className="card col-12 col-md-6 col-lg-3">
                <div className="card-wrapper">
                    <div className="icons-wrap">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-star mobi-mbri"></span>
                        </div>
                    </div>
                    <h5 className="card-title mbr-fonts-style display-4">
                        <strong>Customer service!</strong>
                    </h5>
                    <h5 className="card-subtitle mbr-fonts-style mb-0 display-7">The workers are very polite and attentive. One guy spent 20 minutes to help me.</h5>
                    <div className="card-bottom-wrap">
                        <p className="card-name mbr-fonts-style mb-0 display-7">
                            <strong>Jennifer Bawerman</strong>
                        </p>
                        <p className="card-text mbr-fonts-style mb-0 display-7">
                            Finland
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
    )
})